import React from "react";
import { InputFail } from "~/Components/Form";
import * as Comp from "./style";
import InputProps from "../inputProps";
import { Form, Formik } from "formik";
import { GET_REQUEST } from "../../../../../HooksApi/useApi";
import UseGetData from "../../../../../HookAxios/getdata";
import { useDispatch, useSelector } from "react-redux";
import {
  changeLoading,
  changeStatus,
  changeDiscount,
  changeCode,
} from "../../redux/EnrollPack";
import { useParams } from "react-router-dom";
const AddCoupon = () => {
  const { PackId } = useParams();

  const Sucdeed = useSelector((state) => state.EnrollPack.status);

  const token = useSelector((state) => state.Auth.userInfo.token);

  const dispatch = useDispatch();
  const { inputProps } = InputProps();
  const [Code, setCode] = React.useState("");
  const { isLoading, data, isError, error, refetch } = GET_REQUEST({
    onResault,
    queryKey: "GetCoupon",
    request: () =>
      UseGetData(
        "get_package_coupon_discount",
        { code: Code, package_id: PackId },
        {
          Authorization: `Bearer ${token}`,
        }
      ),
    enabled: false,
  });
  function onResault(data) {
    dispatch(changeStatus(true));
    dispatch(changeDiscount(data.data.data.discount_percentage));
    dispatch(changeCode(Code));
  }
  const onSubmit = (data) => {
    dispatch(changeLoading(true));
    setCode(data.code);
    setTimeout(() => {
      refetch();
    }, 500);
  };
  React.useEffect(() => {
    if (!isLoading) dispatch(changeLoading(false));
  }, [isLoading]);
  return (
    <Comp.CouponComp>
      <Formik
        initialValues={{ code: "" }}
        // validationSchema={formikProps.validationSchema}
        onSubmit={onSubmit}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <Form style={{ width: "100%" }}>
            <Comp.TextCoupon>
              {/* <img src={images.Coupon} alt="" /> */}
              هل لديك رمز بروموكود؟
            </Comp.TextCoupon>
            <InputFail
              name="code"
              onChange={handleChange}
              onBlur={handleBlur}
              inputProps={inputProps}
              placeholder="الرمز"
              value={values.code}
              error={errors.code && touched.code}
              errorText={errors.code && touched.code ? errors.code : null}
            />
          </Form>
        )}
      />
    </Comp.CouponComp>
  );
};

export default AddCoupon;
